import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('fail-safe', {
  library: 'fail-safe',
});
